import {
  HOME_PAGE_URL,
  ABOUT_PAGE_URL,
  LINKS_PAGE_URL,
  CLIPS_FANSITES_PAGE_URL,
  GALLERY_PAGE_URL,
  DOMINATION_PAGE_URL,
  WRESTLING_PAGE_URL,
  SPLOSHING_PAGE_URL,
  BLOG_PAGE_URL,
} from '../Constants';

export const navLinkItemsArray = [
  { path: HOME_PAGE_URL, label: 'Home' },
  { path: ABOUT_PAGE_URL, label: 'About Me' },
  {
    label: 'Services',
    subpages: [
      { path: DOMINATION_PAGE_URL, label: 'Domination' },
      { path: WRESTLING_PAGE_URL, label: 'Wrestling' },
      { path: SPLOSHING_PAGE_URL, label: 'Sploshing' },
    ],
  },
  { path: CLIPS_FANSITES_PAGE_URL, label: 'Clips & Fansites' },
  { path: GALLERY_PAGE_URL, label: 'Gallery' },
  { path: BLOG_PAGE_URL, label: 'Blog' },
  { path: LINKS_PAGE_URL, label: 'Links' },
];
